<template>
  <div class="news">
    <div class="content">
      <cpt-header></cpt-header>
      <el-container>
        <el-main>new</el-main>
      </el-container>
       <cpt-bottom></cpt-bottom>
    </div>
  </div>
</template>

<script>
import cptHeader from '../../components/header/cpt-header.vue';
import cptBottom from '../../components/cpt-bottom.vue';
export default {
  components: {
    cptHeader,
    cptBottom
  },
  data() {
    return {
    }
  },
  methods: {
  },
}

</script>

<style lang='scss' scoped>

</style>